import React from 'react'
import { TwoColumnResponsiveLayout } from 'components/presentation'
import RegItem from '../../../../../../../../../../cart/components/reg-item'
import ReturnComponentForStore from './components/ReturnComponentForStore/ReturnComponentForStore'
import { GiftReturnModalContentProps } from './GiftReturnModalContent.types'

const GiftReturnModalContent: React.FC<GiftReturnModalContentProps> = ({
  daysSincePurchase,
  giftGiverName,
  giftGiverEmail,
  orderNum,
  onFailure,
  onSuccess,
  regItem,
  reservationToken,
  storeName,
}) => {
  const handleSuccess = () => onSuccess?.()
  const handleFailure = () => onFailure?.()

  return (
    <TwoColumnResponsiveLayout key="GiftReturnModal">
      <RegItem className="mbl" regItem={regItem} />
      <ReturnComponentForStore
        daysSincePurchase={daysSincePurchase}
        giftGiverEmail={giftGiverEmail}
        giftGiverName={giftGiverName}
        orderNum={orderNum}
        reservationToken={reservationToken}
        storeName={storeName}
        onFailure={handleFailure}
        onSuccess={handleSuccess}
      />
    </TwoColumnResponsiveLayout>
  )
}

export default GiftReturnModalContent
